export const stripUrlParameters = (url: string): string => {
  try {
    const resultUrl = new URL(url);
    resultUrl.search = ''; // Clear the query string (parameters)
    return resultUrl.toString();
  } catch {
    // if initial url has wrong format, return it
    return url;
  }
};
